import { FaShieldAlt, FaUser } from "react-icons/fa";
import { SortOption } from "../../../components/SortAndFilterSection";

export const sortOptions: SortOption[] = [
  {
    label: "Status",
    id: "status",
  },
  {
    label: "Rolle",
    id: "role",
  },
];

export const selectableFilterOptions = [
  {
    id: "status",
    label: "Status",
    icon: <FaShieldAlt />,
    options: [
      { id: "active", label: "Aktiv" },
      { id: "disabled", label: "Deaktivert" },
    ],
  },
  {
    id: "role",
    label: "Rolle",
    icon: <FaUser />,
    options: [
      { id: "admin", label: "Admin" },
      { id: "user", label: "Bruker" },
    ],
  },
];
